import myRequest from '@/services/myRequest';

export async function getHotSearchList(params) {
  return myRequest('get', '/hotSearch/queryHotList', params);
}

export async function queryHotContent(params) {
  return myRequest('get', '/hotSearch/queryHotContent', params);
}
